import { graphql, navigate } from 'gatsby';
import React, { useRef } from 'react';

import { smoothScrollToRef } from '../components/Common/ScrollTo';
import AgendaHeading from '../components/Generic/AgendaHeading';
import FullCenteredHeading from '../components/Generic/FullCenteredHeading';
import HalfAndHalfHeader from '../components/Generic/HalfAndHalfHeader';
import OverlappingHero from '../components/Generic/OverlappingHero';
import OverUnderHeader from '../components/Generic/OverUnderHeader';
import VideoBkgHero from '../components/Generic/VideoBkgHero';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import { sectionBuilder } from '../tools/sectionBuilder';
import * as styles from './standardMultipurposePage.module.css';

const StandardMultipurposePage = ({ data, location, pageContext }) => {
  let page = {};
  if (data.page) page = data.page;
  const scrollRef = useRef();

  const onCtaClick = (e) => {
    e.preventDefault();
    if (!page.headingCtaScrollsToForm && page.headingCtaUrl) {
      return navigate(page.headingCtaUrl);
    }

    smoothScrollToRef(scrollRef, null, 84);
  };

  let heading;
  if (page.headingStyle === 'Over under') {
    heading = (
      <OverUnderHeader
        ctaLabel={page.headingCtaLabel}
        ctaUrl={page.headingCtaUrl}
        heading={page.heading}
        image={page.headingImage}
        lede={page.headingIntroCopy}
        ctas={page.headingCtAs}
      />
    );
  } else if (page.headingStyle === 'Centered Full Background') {
    heading = (
      <FullCenteredHeading
        heading={page.heading}
        copy={page.headingIntroCopy}
        image={page.headingImage}
        backgroundImage={page.headingBackgroundImage}
        superText={page.headingSuper}
        ctas={page.headingCtAs}
      />
    );
  } else if (
    page.headingStyle === 'Overlapping Bleed' ||
    page.headingStyle === 'Overlapping' ||
    page.headingStyle === 'Overlapping Centered'
  ) {
    heading = (
      <OverlappingHero
        backgroundColor={page.heroBackground}
        copy={page.headingIntroCopy}
        ctaUrl={page.headingCtaUrl}
        hero={page.headingImage}
        heading={page.heading}
        ctaLabel={page.headingCtaLabel}
        center={page.headingStyle === 'Overlapping Centered'}
        videoUrl={page.headingVideoUrl}
        fullBleed={page.headingStyle === 'Overlapping Bleed'}
        ctas={page.headingCtAs}
      />
    );
  } else if (page.headingStyle === 'Half and half' && pageContext.isSpark) {
    heading = <AgendaHeading page={page} />;
  } else if (
    !pageContext.isSpark &&
    (page.headingStyle === 'Half and half' || page.headingStyle === 'Half and half with vertical bleed')
  ) {
    heading = <HalfAndHalfHeader page={page} />;
  } else if (page.headingStyle === 'Movie Background') {
    heading = <VideoBkgHero pageMeta={page} />;
  }

  const sections = sectionBuilder(page, styles, '', pageContext, scrollRef, onCtaClick);

  return (
    <Layout
      isSpark={pageContext.isSpark}
      className={[styles.competitivePage].join(' ')}
      displayCta={page.displayNavCta}
      pageMeta={page.pageMetaData}
      onCtaClick={onCtaClick}
      smoothScroll={page.slug !== 'spark/agenda'}
    >
      <MarketingSeo meta={page.pageMetaData} slug={location.pathname} />
      {heading}
      {sections}
    </Layout>
  );
};

export default StandardMultipurposePage;

export const query = graphql`
  query StandardMultipurposePageTemplateQuery($slug: String!) {
    page: contentfulMultipurposePageTemplate(slug: { eq: $slug }) {
      ...MultipurposePage
    }
  }
`;
